import {NAV_OWNER} from '@/constants';
import {Category, KeyImageType} from '@/types';
import {CatalogOffer, Image} from 'epic-graphql-types';
import {isEmpty, isNil} from 'lodash';

/*
    TODO:
    NOTE: It should be in a hierarchy order
    ex: for a base game category it will be [game, game/edition, game/edition/base], so it could return either of GAMES, GAMES_EDITION, GAMES_EDITION_BASE depends on the map order
*/

// Map of Category Names to Message code
const CategoryNames = [
	{category: Category.GAMES_EDITION_BASE, name: 'epic.app.products.game.base.subheading.tag'},
	{category: Category.GAMES_DEMO, name: 'epic.app.products.demo.subheading.tag'},
	{category: Category.GAMES_EDITION, name: 'epic.app.products.edition.subheading.tag'},
	{category: Category.GAMES_EXPERIENCE, name: 'diesel.common.category.experience'},
	{category: Category.SUBSCRIPTION, name: 'diesel.common.category.subscription'},
	{category: Category.ADDONS, name: 'epic.app.products.addon.subheading.tag'},
	{category: Category.DIGITAL_EXTRAS, name: 'epic.app.products.addon.subheading.tag'},
	{category: Category.BUNDLES, name: 'epic.app.products.bundle.subheading.tag'},
	{category: Category.BUNDLES_GAMES, name: 'epic.app.products.bundle.subheading.tag'},
	{category: Category.MODS, name: 'epic.app.products.mod.subheading.tag'},
	{category: Category.COLLECTIONS, name: 'epic.app.products.collection.subheading.tag'},
	{category: Category.EDITORS, name: 'epic.app.products.editor.subheading.tag'},
	{category: Category.ENGINES, name: 'epic.app.products.engine.subheading.tag'},
	{category: Category.GAMES, name: 'epic.app.products.game.subheading.tag'},
	{
		category: Category.ASSETS_CHARACTERS,
		name: 'epic.app.products.asset.character.subheading.tag'
	},
	{category: Category.ASSETS, name: 'epic.app.products.asset.subheading.tag'},
	{category: Category.SOFTWARE, name: 'epic.app.products.category.software'},
	{category: Category.SOFTWARE_EDITION_BASE, name: 'epic.app.products.category.software'},
	{category: Category.APPLICATIONS, name: 'epic.app.products.category.software'}
];

export const getTagByCategories = (categories?: CatalogOffer['categories']) => {
	if (!isNil(categories) && !isEmpty(categories)) {
		const category = CategoryNames.find((categoryName) =>
			categories.find((category) => category?.path === categoryName.category)
		);
		return category ? {category: category.category, messageCode: category.name} : undefined;
	}
	return undefined;
};

export const getOfferStoreUrl = (offer: CatalogOffer) => {
	if (!offer) return null;
	const baseUrl = process.env.NEXT_PUBLIC_STORE_URL;
	const slug = offer.offerMappings?.[0]?.pageSlug || offer.urlSlug;
	const productUrl = `${baseUrl}/p/${slug}`;
	const url = new URL(productUrl);
	url.searchParams.set('source', NAV_OWNER);
	return url.toString();
};

export const getOfferKeyImages = <T extends KeyImageType>(
	keyImages: CatalogOffer['keyImages'],
	keyImageTypes: T[]
): Map<T, Image> => {
	const toReturn = new Map<T, Image>();

	if (!keyImages?.length) {
		return toReturn;
	}

	const keyImageTypesMap = new Set(keyImageTypes);

	for (const keyImage of keyImages) {
		const key = keyImage?.type as T;
		if (keyImageTypesMap.has(key)) {
			toReturn.set(key, keyImage!);
		}
	}

	return toReturn;
};
